 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~accusation~activity~agreement~question":"about~accusation~activity~agreement~question","about~accusation~communication~question":"about~accusation~communication~question","accusation":"accusation","question":"question","activity":"activity","communication":"communication","bulletin":"bulletin","about":"about","agreement":"agreement","safety":"safety","auth":"auth","study":"study","utils":"utils"}[chunkId]||chunkId) + "." + {"about~accusation~activity~agreement~question":"b616e056","about~accusation~communication~question":"be9be432","chunk-0afb411c":"bf164d02","accusation":"ecd932c0","question":"6b7a2ecb","activity":"87aca521","communication":"624b60e3","bulletin":"0e75b15d","chunk-0b370ad9":"37d588f3","chunk-27159975":"66533b99","chunk-4006899a":"1367356c","chunk-75faa2d0":"66f7da4c","chunk-cdc9ba7a":"fab34655","about":"2ab6e073","agreement":"1f4ab9d3","chunk-58aceb73":"1e108687","chunk-67ed2812":"a6fe2f3d","chunk-766a0a2d":"e6d69ab2","chunk-2b6d1c8b":"80884ae7","chunk-4b4557f0":"ca539d03","chunk-79cd9d7f":"2e8579d8","chunk-876a3880":"335911e2","chunk-98a4409e":"af3b6c1d","chunk-46e4c853":"57a0c693","safety":"b675b48d","chunk-ae1370f6":"242acbe9","auth":"a8f659d1","study":"2a5ef81b","utils":"0e6ebd91","chunk-180faa5d":"989315ca","chunk-778ee936":"249fa946","chunk-a7ae90ba":"8d798f08","chunk-b554c0dc":"6829ce4b","chunk-0c7062a6":"de04d5a5","chunk-218dc1c7":"248dc31c","chunk-5a157600":"9d01627f","chunk-6cc030dc":"e612a5e8","chunk-7c0c099d":"5ab91efa","chunk-9463e196":"6bd448f9","chunk-fd93b92a":"6d39cd73","chunk-23ebee71":"cb30b5a4","chunk-141d6e46":"548a70d5","chunk-69491078":"8ba91a56","chunk-5c367a1a":"5800e678","chunk-259c864b":"3cf0939f","chunk-2b04c7ac":"cb376480","chunk-e11c0390":"e0ff078e","chunk-ffac9916":"b76adbb9","chunk-1f94e042":"7eecef83"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~accusation~activity~agreement~question":1,"about~accusation~communication~question":1,"chunk-0afb411c":1,"accusation":1,"question":1,"activity":1,"communication":1,"bulletin":1,"chunk-0b370ad9":1,"chunk-27159975":1,"chunk-4006899a":1,"chunk-cdc9ba7a":1,"about":1,"agreement":1,"chunk-58aceb73":1,"chunk-67ed2812":1,"chunk-766a0a2d":1,"chunk-2b6d1c8b":1,"chunk-4b4557f0":1,"chunk-79cd9d7f":1,"chunk-876a3880":1,"chunk-46e4c853":1,"safety":1,"chunk-ae1370f6":1,"auth":1,"study":1,"utils":1,"chunk-23ebee71":1,"chunk-141d6e46":1,"chunk-69491078":1,"chunk-5c367a1a":1,"chunk-259c864b":1,"chunk-1f94e042":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~accusation~activity~agreement~question":"about~accusation~activity~agreement~question","about~accusation~communication~question":"about~accusation~communication~question","accusation":"accusation","question":"question","activity":"activity","communication":"communication","bulletin":"bulletin","about":"about","agreement":"agreement","safety":"safety","auth":"auth","study":"study","utils":"utils"}[chunkId]||chunkId) + "." + {"about~accusation~activity~agreement~question":"66ab5faa","about~accusation~communication~question":"60d3d41b","chunk-0afb411c":"5f6b1219","accusation":"39bd9752","question":"818f7955","activity":"02b3778a","communication":"b26d3b78","bulletin":"522c1881","chunk-0b370ad9":"c8c01ce9","chunk-27159975":"53739266","chunk-4006899a":"5217176e","chunk-75faa2d0":"31d6cfe0","chunk-cdc9ba7a":"043cf17b","about":"134c52f3","agreement":"f80eb310","chunk-58aceb73":"def0662b","chunk-67ed2812":"06403cb8","chunk-766a0a2d":"6da6c472","chunk-2b6d1c8b":"a33985d6","chunk-4b4557f0":"25e6a652","chunk-79cd9d7f":"c00c0942","chunk-876a3880":"72540df3","chunk-98a4409e":"31d6cfe0","chunk-46e4c853":"142e5bb5","safety":"e040f1d5","chunk-ae1370f6":"1be41e4b","auth":"2d796a5c","study":"00e06cc0","utils":"0fe01086","chunk-180faa5d":"31d6cfe0","chunk-778ee936":"31d6cfe0","chunk-a7ae90ba":"31d6cfe0","chunk-b554c0dc":"31d6cfe0","chunk-0c7062a6":"31d6cfe0","chunk-218dc1c7":"31d6cfe0","chunk-5a157600":"31d6cfe0","chunk-6cc030dc":"31d6cfe0","chunk-7c0c099d":"31d6cfe0","chunk-9463e196":"31d6cfe0","chunk-fd93b92a":"31d6cfe0","chunk-23ebee71":"bad3179b","chunk-141d6e46":"c046d4d4","chunk-69491078":"000f0886","chunk-5c367a1a":"47dca8ac","chunk-259c864b":"e177cb19","chunk-2b04c7ac":"31d6cfe0","chunk-e11c0390":"31d6cfe0","chunk-ffac9916":"31d6cfe0","chunk-1f94e042":"bfd553df"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sgapp-res/act-static/h5-app-niceProperty/20240514110627/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
